// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__-UBXl","footer":"ModalError_footer__2NapM"};